import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { ChatClientDto } from '../../dtos/chat-client.dto';

@Injectable()
export class ChatClientsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // `LocalClientsService.GetClientsAsync` has no text-search parameter -- callers filter the
  // returned list client-side (see `ChatClientsRepositoryImpl`/`CommunicationPage`).
  public listPetOwners(organizationId: number): Observable<readonly ChatClientDto[]> {
    return this.http.get<readonly ChatClientDto[]>(`${this.apiUrl}${API_ENDPOINTS.organizationClients.list(organizationId)}`, {
      params: { accountRealm: 'pet_owner' },
    });
  }
}
